export default "__VITE_ASSET__$t6sfQUE__"